import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {GGGameConfig} from "../GGGameConfig";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";

export class GGSpinController extends SpinController {

    // #576
    protected getReelsGameConfigFromPreviousGameData(): boolean[] {
        if (GGGameConfig.instance.FAULTY_WIN_CAP) {
            SlotGame.keypad.hide();
            return ArrayHelper.initArrayWithValues(GGGameConfig.instance.REELS_NUM, () => false);
        }

        return super.getReelsGameConfigFromPreviousGameData();
    }

    public doAS(data:any){
        (<any>this)._screenManager.parseGameData(data);
        (<any>this)._screenManager.tryPlayScreens(data);

    }
}